import { AccountsRedirectionKey } from '@accredible-frontend-v2/services/accounts-redirection';
import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SilentLoginService {
  private readonly _document = inject(DOCUMENT);
  private _cached: boolean | null = null;

  isSilentLogin(): boolean {
    if (this._cached !== null) {
      return this._cached;
    }
    const urlParams = new URLSearchParams(this._document.location.search);
    this._cached =
      urlParams.get(AccountsRedirectionKey.APP) === 'ler' &&
      urlParams.has(AccountsRedirectionKey.SILENT) &&
      urlParams.has(AccountsRedirectionKey.ORIGIN);
    return this._cached;
  }
}
